import React from 'react';

// ** Styles
import { PartnersListStyled } from './partners-list.styled';

// ** Hooks
import { usePartnersData } from 'data/hooks/partners/use-partners-data';

// ** Components
import { Partner } from 'sections/partners';

export const PartnersList = () => {
  const { partners } = usePartnersData();

  return (
    <PartnersListStyled>
      {partners.map((partner) => (
        <Partner key={partner.id} {...partner} />
      ))}
    </PartnersListStyled>
  );
};
